import { useState, useCallback } from 'react';
import * as yup from 'yup';

const schema = yup.object().shape({
  password: yup
    .string()
    .trim()
    .min(6, 'A senha deve ter no mínimo 6 caracteres')
    .required('Senha é obrigatória'),
  confirmPassword: yup
    .string()
    .trim()
    .oneOf([yup.ref('password'), null], 'As senhas devem ser iguais')
    .required('Confirmação de senha é obrigatória'),
});

const defaultValues = {
  password: '',
  confirmPassword: '',
};

export const useFirstAccess = ({
  initialValues = defaultValues,
  validationSchema = schema,
}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((fieldName, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  }, []);

  const trigger = useCallback(
    async (fieldNames) => {
      const fieldsToValidate =
        fieldNames || Object.keys(validationSchema.fields);

      const partialSchema = yup.object(
        fieldsToValidate.reduce((acc, field) => {
          acc[field] = validationSchema.fields[field];
          return acc;
        }, {}),
      );

      try {
        await partialSchema.validate(values, { abortEarly: false });

        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          fieldsToValidate.forEach((field) => delete newErrors[field]);
          return newErrors;
        });

        return true;
      } catch (err) {
        if (err instanceof yup.ValidationError) {
          const newErrors = err.inner.reduce((acc, error) => {
            acc[error.path] = error.message;
            return acc;
          }, {});

          setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            fieldsToValidate.forEach((field) => delete updatedErrors[field]);
            return { ...updatedErrors, ...newErrors };
          });
        }
        return false;
      }
    },
    [values, validationSchema],
  );

  return {
    values,
    errors,
    handleChange,
    trigger,
    setValues,
    setErrors,
  };
};
